const API_BASE_URL = process.env.REACT_APP_BACKEND_URL;

export const getImageUrl = (path) => {
    if (!path) {
        return '/default-avatar.svg'; // Fallback
    }
    if (path.startsWith('data:') || path.startsWith('blob:')) {
        return path; // Base64 or local preview
    }
    // If it's already an absolute URL (http/https///domain.com), return as is.
    // The '//' check handles protocol-relative URLs.
    if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('//')) {
        return path;
    }

    // Ensure API_BASE_URL does not end with a slash and path does not start with a slash
    // before concatenating, to prevent double slashes like 'domain.com//path'
    let baseUrl = API_BASE_URL;
    if (baseUrl && baseUrl.endsWith('/')) {
        baseUrl = baseUrl.slice(0, -1);
    }

    let cleanPath = path;
    if (cleanPath.startsWith('/')) {
        cleanPath = cleanPath.substring(1);
    }
    
    // Relative path: Prepend API URL
    return `${baseUrl}/${cleanPath}`;
};